module.exports = __webpack_public_path__ + "1e41dcfaddd72d33629e6398eb1898f8.fbx";